export function _coverSizeImage(nativeWidth, nativeHeight, containerWidth, containerHeight) {
  let width = 0
  let height = 0
  if (containerHeight / containerWidth > nativeHeight / nativeWidth) {
    width = containerHeight * (nativeWidth / nativeHeight)
    height = containerHeight
  } else {
    width = containerWidth
    height = containerWidth * (nativeHeight / nativeWidth)
  }
  return {
    width : width,
    height: height
  }
}

export function getCoverValue(mediaWidth, mediaHeight, containerWidth, containerHeight) {
  let width = 0
  let height = 0
  let top = 0
  let left = 0
  if (containerHeight / containerWidth > mediaHeight / mediaWidth) {
    width = containerHeight * (mediaWidth / mediaHeight)
    height = containerHeight
  } else {
    width = containerWidth
    height = containerWidth * (mediaHeight / mediaWidth)
  }
  top = (containerHeight - height) / 2
  left = (containerWidth - width) / 2
  return {
    width : width,
    height: height,
    top: top,
    left: left,
  }
}



export function pathLength($item){
  $item.each(function(){
    $(this).find('path').each(function(){
      let $path = $(this)
      let length = $path[0].getTotalLength()
      $path.attr('data-dash-length', length)
      $path.css('stroke-dashoffset', length)
      $path.css('stroke-dasharray', length)
    })
  })
}

export function getSizeSrcFromSrcset(el, customWidth = null) {
  const width = customWidth ? Math.floor(customWidth) : Math.floor(el.offsetWidth);

  const srcset = el.getAttribute('data-srcset') || el.getAttribute('srcset');
  if (!srcset) return null;

  const sources = srcset.split(',').map(item => item.trim().split(' '));
  const candidates = sources.map(source => ({
    url: source[0],
    width: parseInt(source[1].replace(/[^\d]/g, ''), 10)
  }));

  const closest = candidates.reduce((prev, curr) =>
    Math.abs(curr.width - width) < Math.abs(prev.width - width) ? curr : prev
  );

  return closest.url;
}





export function getSizeSrc($el){
  let width = Math.floor($el.outerWidth())

  let sizes = []
  let smartSrc = $el.attr('data-smartsrc')


  smartSrc = smartSrc.split(',').map(function(item){
    return item.trim()
  })
  for (var i = 0; i <= smartSrc.length-1; i++) {
    smartSrc[i] = smartSrc[i].split(' ')
    let size = parseInt(smartSrc[i][1].replace(/[^0-9\.]+/g,""))
    sizes.push(size)
  }

  const closest = utils.closest(width, sizes)
  const idUsed = sizes.indexOf(closest)
  const goodSrcBySize = smartSrc[idUsed][0]

  return goodSrcBySize
}

export function canDraw(oldValue, newValue, decimal){
  return deci(oldValue, decimal) !== deci(newValue, decimal)
}

export function deci(val, decimal) {
  return parseFloat(val.toFixed(decimal))
}

export function normalizeRange (value, inputMin, inputMax, outputMin, outputMax)  {
  const originalRange = inputMax - inputMin
  const newRange = outputMax - outputMin
  return (((value - inputMin) * newRange) / originalRange) + outputMin
}

export function lerp (start, end, amt){
  return (1-amt)*start+amt*end
}

export function clamp(val, min, max) {
  return Math.min(Math.max(val, min), max)
}


// _____________________________ closest element from array
// _______________________________________________________
export function closest(x, arr) {
  let indexArr = arr.map(function (k) {
    return Math.abs(k - x)
  })
  let min = Math.min.apply(Math, indexArr)
  return arr[indexArr.indexOf(min)]
}


// closest
// lerp
// normalizeRange
// getCoverValue
// deci
// canDraw
// getSizeSrc
// pathLength

// _coverSizeImage